import { memo } from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { Modal } from 'rsuite';
import { RootState } from '../../@types/RootState';
import gif from '../../assets/image/mpdv-banner-lead.gif';
import { ReactComponent as Logo } from '../../assets/logo/logo-ISA-MPDV-branco.svg';
import { selectorUser } from '../../lib/selectorUser';
import { sendLead } from '../../pages/ISA/InfoPanel/InfoPanel/utils';
import { selectorNavBarModals, SET_IS_OPEN } from '../../reducers/navBar/modals';
import { trackEvent } from '../../utils/MatomoConfig';
import styles from './ModalMPDVLead.module.scss';

type ModalMPDVLeadProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ModalMPDVLead = ({ show, onHide }: ModalMPDVLeadProps) => {
  const user = useSelector(selectorUser);

  const handleClick = async () => {
    const confirm = window.confirm('Deseja entrar em contato com a nossa equipe?');
    if (!confirm) return;
    sendLead(user, 'Monitoramento de concorrentes');
    trackEvent('Upsell/Crossell', 'crossell', 'Monitoramento de concorrentes');
    window.open('https://wa.me/551137779670?text=Ol%C3%A1%21+Quero+saber+mais+sobre+o+ISA+-+Monitoramento+PDV');
    onHide?.();
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modal}>
      <Modal.Body className={styles.modal__content}>
        <Logo className={styles.logo} />
        <h2 className={styles.title}>
          Potencialize seu processo de
          <strong> monitoramento de concorrentes </strong>
          com o Monitoramento PDV
        </h2>
        <div className={styles.img__container}>
          <img src={gif} alt="Imagem animada demonstrando o funcionamento da aplicação" />
          <span>Garanta agilidade na coleta e nas decisões do seu negócio com tecnologia e treinamento para o seu time</span>
        </div>
        <ul>
          <li>Hardware SmartPrice que coleta dados de preço no PDV</li>
          <li>Tratamento dos dados coletados que garantem confiabilidade</li>
          <li>Treinamento e padronização de processos da coleta de preços</li>
          <li>Acompanhamento das coletas, revisão de listas e avaliação de retorno no painel</li>
        </ul>
        <button onClick={handleClick}>CONHEÇA O MONITORAMENTO PDV</button>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  show: selectorNavBarModals(state).COL,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(SET_IS_OPEN({ key: 'COL', payload: false })),
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(ModalMPDVLead));
